var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgECommerceIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.063 22.286h-1.378c.24-.47.378-1 .378-1.563v-15a3.441 3.441 0 00-3.438-3.437H5.375a3.441 3.441 0 00-3.438 3.437v15c0 .563.137 1.094.378 1.563H.938a.938.938 0 00-.938.937v2.5a3.441 3.441 0 003.438 3.438h25.125A3.441 3.441 0 0032 25.723v-2.5a.938.938 0 00-.938-.937zm-27.25-1.563v-15c0-.861.7-1.562 1.562-1.562h21.25c.862 0 1.563.7 1.563 1.562v15c0 .862-.701 1.563-1.563 1.563H5.375c-.862 0-1.563-.701-1.563-1.563zm26.312 5c0 .862-.7 1.563-1.563 1.563H3.438c-.861 0-1.562-.701-1.562-1.563v-1.562h28.25v1.562z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 9.786h-8.58l-.183-1.092a.937.937 0 00-.924-.783H13.5a.937.937 0 100 1.875h1.393l1.12 6.716a.937.937 0 00.924.784h.313v.937a.937.937 0 101.875 0v-.937h3.125v.937a.937.937 0 101.875 0v-.937h.313c.458 0 .849-.332.924-.784l.938-5.625a.938.938 0 00-.925-1.091zm-1.732 5.625h-5.911l-.625-3.75h7.161l-.625 3.75zM11 9.16H8.5a.938.938 0 000 1.876H11a.937.937 0 100-1.875zM11 12.91H6.625a.938.938 0 000 1.876H11a.937.937 0 100-1.875zM11 16.66H8.5a.938.938 0 000 1.876H11a.937.937 0 100-1.875z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/eCommerce-industry.60c42bc893b97589394db4a5c2579141.svg";
export { SvgECommerceIndustry as ReactComponent };